import DashboardLayout from "./layout/DashboardLayout";
import JoinedRoom from "./RoomComponent";

const Room = () => {
  return (
    <DashboardLayout>
      <JoinedRoom />
    </DashboardLayout>
  );
};

export default Room;
